import { createSelector } from "@reduxjs/toolkit";
import selectUsersRaw from "./selectUsersRaw";

export default createSelector(selectUsersRaw, ({ currentUser }) => currentUser);
